import { useCallback } from 'react'

import { useFormikContext } from 'formik'

import type { ConditionModel } from '../../../typings'
import { useTranslation } from 'react-i18next'

type Props = {
  setOpen?: (value: boolean) => void
  save?: (value: ConditionModel) => Promise<boolean>
  cancel?: () => void
}

export function useHandlers(props: Props) {
  const { setOpen, save, cancel } = props
  const {
    setValues,
    setFieldTouched,
    values: { matchType },
    errors,
  } = useFormikContext<Partial<ConditionModel>>()
  const { t } = useTranslation()

  const handleSave = useCallback(
    async (values, zipCodeValid, setErrors, setSubmitting) => {
      // Without this change zip error from not valid to required (if we havent chips but have text in input)
      if (!zipCodeValid) {
        setErrors({
          assignmentRuleConditionValues: t('postalCodeInvalid'),
        })
      }

      if (!errors.assignmentRuleConditionValues) {
        const saved = save ? await save(values) : true

        if (saved && setOpen) {
          setOpen(false)
        }
      }

      setSubmitting(false)
    },
    [errors.assignmentRuleConditionValues, save, setOpen],
  )

  const handleAttributeChange = useCallback(
    (event: any) => {
      setValues({
        assignmentRuleConditionValues: [],
        attribute: event.target.value,
        matchType,
      })
      setFieldTouched('assignmentRuleConditionValues', false)
    },
    [setFieldTouched, setValues, matchType],
  )

  const handleDialogClose = useCallback(
    (_event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
      if (reason === 'backdropClick') {
        console.log(reason)
      } else {
        if (cancel) {
          cancel()
        }
      }
    },
    [cancel],
  )

  return {
    handleSave,
    handleAttributeChange,
    handleDialogClose,
  }
}
